import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';

const themeQuery = window.matchMedia?.('(prefers-color-scheme: dark)');

const refreshFavicon = () => {
  const favicon = document.querySelector('link[type="image/svg+xml"]');

  if (favicon) {
    const theme = themeQuery?.matches ? 'dark' : 'light';
    favicon.href = `${process.env.PUBLIC_URL}/favicon.svg?theme=${theme}&v=${Date.now()}`;
  }
};

refreshFavicon();

if (themeQuery) {
  if (themeQuery.addEventListener) {
    themeQuery.addEventListener('change', refreshFavicon);
  } else {
    themeQuery.addListener(refreshFavicon);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
